import { z } from 'zod';
import type { MainBlockWithoutDestination } from './common';

export type DeciderLogic =
  | 'decideBasedOnRules'
  | 'decideByNumber'
  | 'decideBasedOnText'
  | 'decideByCurrentDateHours'
  | 'decideByWorkingHours'
  | 'decideQuizWinner'
  | 'decideBasedOnPromotion'
  | 'decideByOrderOfUser'
  | 'decideIfCouponsForTypeExist'
  | 'decideByEquality'
  | 'decideByTime'
  | 'decideByLLMQuestionCount'
  | 'decideByRecentLLMQuestionThreshold';

export const operatorList = [
  'eq',
  'ge',
  'le',
  'gt',
  'lt',
  'ne',
  'exists',
  'includes',
  'startsWith',
  'endsWith',
] as const;

interface DeciderDestination {
  blockId: string;
  rules?: TDecideRule[];
  rule?: TDecideRule;
}

interface DeciderParams {
  logic: DeciderLogic;
  possibleDestinations: DeciderDestination[];
  field?: string;
  modulo?: number;
  threshold?: number;
  type?: 'grab';
  preformatter?: any;
}

export interface Decider extends MainBlockWithoutDestination {
  type: 'Decider';
  params: DeciderParams;
}

export const TDecideRuleSchema = z.object({
  operator: z.enum(operatorList),
  operand: z.any(),
});

export type TDecideRule = z.infer<typeof TDecideRuleSchema>;
